import React, { Component } from 'react';
import {
  GeckoToast,
  GeckoDialog,
  GeckoModalWrapper,
  GeckoLoading,
} from '../../';

class GeckoGlobal extends Component {
  render() {
    return (
      <div>
        <GeckoModalWrapper />

        <GeckoToast />

        <GeckoDialog />

        <GeckoLoading />
      </div>
    );
  }
}

export default GeckoGlobal;
